// extracted by mini-css-extract-plugin
module.exports = {"signatureCard":"signatureCard_signatureCard__30oBH","imageUrl":"signatureCard_imageUrl__qGpEJ","label":"signatureCard_label__25Sim"};